import {Graphics, InteractionEvent, Sprite, Texture} from 'pixi.js';
import {StaticData} from '../../../../../../../data/StaticData';
import {TextureUrlLoader} from '../../../../../../../utils/TextureUrlLoader';

export class VideoSeatMuteButton extends Sprite
{
    graphicsBg: Graphics;
    icon: Sprite | undefined;

    constructor(private iconPath: string, private colorEnabled: number, private colorDisabled: number, private onClick: Function) {
        super();

        this.graphicsBg = new Graphics();
        this.graphicsBg.interactive = true;
        this.addChild(this.graphicsBg);

        this.setEnabled();

        this.graphicsBg.on('pointerdown', this.onPointerDown, this);
        this.loadIcon();
    }

    destroy(): void {
        this.graphicsBg.off('pointerdown', this.onPointerDown, this);
        super.destroy({children: true});
    }

    setEnabled(value: boolean = true) {
        this.draw(value ? this.colorEnabled : this.colorDisabled);
    }

    private onPointerDown(e: InteractionEvent): void {
        this.onClick();
    }

    private draw(color: number) {
        this.graphicsBg.clear();
        this.graphicsBg.beginFill(color);
        this.graphicsBg.drawCircle(0, 0, StaticData.videoSeatBottomBarMuteButtonsRadius);
        this.graphicsBg.endFill();
    }

    private async loadIcon() {
        let iconTexture: Texture | null = await TextureUrlLoader.load(this.iconPath);
        this.icon = new Sprite(iconTexture!);
        this.icon.anchor.set(.5, .5);
        this.addChild(this.icon).interactive = false;
    }
}
